export enum FirebaseStorageKeys {
    companyImage = 'company-image',
    branchImage = 'branch-image',
    userImage = 'user-image'
}
